<template>
  <div class="card-header">
    <div class="header-top">
      <div class="resource_icon">
        <i class="bi bi-file-earmark-arrow-up-fill" />
      </div>
      <div
        v-if="resourceDataFormats.length && resource.fileupload.dataformat && resource.fileupload.dataformat.length>0"
        class="resource_format"
      >
        {{ resourceDataFormats.find(el => el.codename === resource.fileupload.dataformat).codename }}
      </div>
      <div class="resource_name">
        {{
          resource.fileupload && resource.fileupload.href ?
            resource.fileupload.href.split('/').slice(-1)[0] :
            ''
        }} 
        <i v-if="resource && resource.fileupload">({{ fileSize }})</i>
      </div>
    </div>
    <div 
      v-if="resource.source_layer_list &&resource.source_layer_list.length > 1"
      class="form-group col-12"
    >
      <label>
        {{ $t('resource.fileUpload.sourceLayer.label') }}
      </label>
      <Multiselect
        :value="selectedSourceLayer"
        :options="resource.source_layer_list"
        :placeholder="$t('resource.fileUpload.sourceLayer.placeholder')"
        :searchable="false"
        @input="onSourceLayerChange"
      />
    </div>
    <div class="header-bottom">
      <slot name="publication" />
      <div
        class="form-group"
        style="display: flex; justify-content: flex-end;"
      >
        <b-button
          :id="uploadId"
          variant="outline-secondary"
          :style="'margin-right: 1rem;'"
          @click="isUpdateResourceFileModalOpen = true"
        >
          <b-icon-upload />
        </b-button>
        <b-popover
          :target="uploadId"
          placement="topleft"
          triggers="hover"
          title="Mettre à jour"
          content="Importer un nouveau fichier"
        />
        <b-button
          v-if="fileUrl"
          :id="downloadId"
          variant="outline-primary"
          :href="fileUrl"
        >
          <b-icon-download />
        </b-button>
        <b-popover
          v-if="resource.fileupload && resource.fileupload.href"
          :target="downloadId"
          placement="topright"
          triggers="hover"
          title="Télécharger"
          :content="`${resource.fileupload.href.split('/').slice(-1)[0]}`"
        />
      </div>
    </div>
    <UpdateFileUploadModal
      v-if="isUpdateResourceFileModalOpen"
      :open="isUpdateResourceFileModalOpen"
      :format="
        resourceDataFormats.find(el => resource.fileupload.dataformat && resource.fileupload.dataformat.length > 0 ? el.codename === resource.fileupload.dataformat : 1)
      "
      :resource="editResource"
      :form-config="$config.forms.resource['file-upload']"
      @hide="isUpdateResourceFileModalOpen = false"
      @update="modifyFileUploadFile"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { fileConvertSize } from '@/utils';
import Multiselect from 'vue-multiselect';
import UpdateFileUploadModal from '@/components/Resource/modals/UpdateFileUploadModal.vue'; 
import Resource from '../../../models/resource.js';
export default {
  name: 'FileUploadEditor',

  components: {
    UpdateFileUploadModal,
    Multiselect
  },

  props: {
    isMain: {
      type: Boolean,
      default: true
    },
    resource: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      isUpdateResourceFileModalOpen: false,
      editResource: null,
      selectedSourceLayer: null,
    };
  },

  computed: {
    ...mapState('resources', [
      'resourceDataFormats',
    ]),

    fileSize() {
      if (this.resource.fileupload) {
        return fileConvertSize(this.resource.fileupload.size);
      }
      return '0';
    },

    uploadId() {
      return `upload-button-${this.resource.id}`;
    },

    downloadId() {
      return `download-button-${this.resource.id}`;
    },

    fileUrl() {
      if (this.resource.fileupload && this.resource.fileupload.href) {
        return new URL(this.resource.fileupload.href, window.location.origin).href;
      }
      return null;
    },
  },

  watch: {
    'resource.source_layer'(value) {
      this.selectedSourceLayer = value;
    },
  },

  mounted() {
    this.editResource = new Resource({ ...this.resource });
    this.selectedSourceLayer = this.resource.source_layer;
    // Watch modal closing event
    this.$root.$on('bv::modal::hide', () => {
      this.isUpdateResourceFileModalOpen = false;
    });
  },

  methods: {
    ...mapMutations('modal', [
      'OPEN_MODAL',
    ]),

    onSourceLayerChange(newLayer) {
      const previousLayer = this.selectedSourceLayer;
      if (newLayer === previousLayer) {
        return;
      }

      this.OPEN_MODAL({
        modal: 'confirmation',
        open: true,
        title: this.$t('resource.fileUpload.sourceLayer.confirmTitle'),
        content: this.$t('resource.fileUpload.sourceLayer.confirmContent', {
          layer: newLayer,
          previousLayer,
        }),
        trigger: () => this.confirmSourceLayerChange(newLayer),
      });
    },

    confirmSourceLayerChange(newLayer) {
      this.selectedSourceLayer = newLayer;
      this.resource.source_layer = newLayer;
      this.$emit('modify', {
        type: this.isMain ? 'resource' : 'annexe',
        resource: this.resource,
      });
    },

    modifyFileUploadFile(e) {
      this.resource=e;
      this.$emit('modify', {
        type: this.isMain ? 'resource' : 'annexe',
        resource:this.resource,
        data: {
          format: e.format,
          file: e.file,
        }
      });
    },
  }
};
</script>